module.exports = __webpack_public_path__ + "static/media/Pennsylvania_DMA.42c5db93.jpg";